module.exports = __webpack_public_path__ + "img/l1.a461dc64.png";